import Slider, { SliderProps } from '@react-native-community/slider'
import { isWeb } from 'tamagui'

interface IRangeInputProps extends SliderProps {
  foregroundColor?: string
  rangeColor?: string
  min?: number
  max?: number
  height?: number
}

export function RangeInput({
  min = 0,
  max = 100,
  foregroundColor = '$progress-track',
  rangeColor = '$accent',
  onValueChange,
  onSlidingComplete,
  value,
  children,
}: IRangeInputProps) {
  // No web o @react-native-community/slider quebra (usa ReactDOM.findDOMNode,
  // removido no React 19). Usa um <input type="range"> nativo do browser.
  if (isWeb) {
    const handleCommit = (event: { target: { value: string } }) =>
      onSlidingComplete?.(Number(event.target.value))
    return (
      <input
        type="range"
        min={min}
        max={max}
        step={1}
        value={value ?? 0}
        onChange={(e) => onValueChange?.(Number(e.target.value))}
        onMouseUp={handleCommit}
        onTouchEnd={handleCommit}
        style={{
          width: '100%',
          accentColor: typeof rangeColor === 'string' ? rangeColor : undefined,
          cursor: 'pointer',
        }}
      />
    )
  }

  return (
    <Slider
      style={{
        width: '100%',
      }}
      minimumValue={min}
      maximumValue={max}
      minimumTrackTintColor={rangeColor}
      maximumTrackTintColor={foregroundColor}
      value={value}
      onValueChange={onValueChange}
      onSlidingComplete={onSlidingComplete}
      thumbTintColor={rangeColor}
      step={1}
    >
      {children}
    </Slider>
  )
}
